import { isEmpty } from 'lodash-es'
import * as Yup from 'yup'

import {
  HTML,
  HTML_NOT_SCRAPEABLE,
  IMAGE,
  PDF,
} from '../../../../menus/constants'

const resolveMenuScrapingTaskSchema = Yup.object().shape({
  menu: Yup.object().shape({
    format: Yup.string().required('Format is required'),

    scrapingInstructions: Yup.string()
      .when('format', {
        is: format => format === HTML,
        then: Yup.string().required('Scraping instructions are required'),
      })
      .nullable(),

    notScrapeableReason: Yup.string()
      .when('format', {
        is: format => format === HTML_NOT_SCRAPEABLE,
        then: Yup.string().required('Not scrapeable reason is required'),
      })
      .nullable(),
  }),
  menuDocumentFiles: Yup.array().when('menu.format', {
    is: format => format === PDF || format === IMAGE,
    then: Yup.array().of(
      Yup.object().shape({
        fileCategory: Yup.mixed().test(
          'fileCategory-required',
          'File category is mandatory',
          // eslint-disable-next-line func-names
          function(value) {
            return !isEmpty(value)
          },
        ),
        fileTitle: Yup.mixed().test(
          'fileTitle-required',
          'File title is required',
          // eslint-disable-next-line func-names
          function(value) {
            const { isSelected } = this.parent
            if (!isSelected) {
              return true
            }
            return !isEmpty(value)
          },
        ),
      }),
    ),
  }),
})

export default resolveMenuScrapingTaskSchema
